<template>
  <validation-observer
    ref="formRules"
    v-slot="{ invalid }"
  >
    <div class="p-0">
      <b-row v-if="questionItems.length">
        <b-col
          md="8"
        >
          <b-form-group
            label-class="font-medium text-7 text-black"
            label="Kuisioner"
            label-cols-md="4"
          >
            <b-col
              v-for="(item, index) in questionItems"
              :key="`item-${item.id}`"
              md="12"
              class="p-0"
            >
              <b-form-group
                :label="item.question"
                :label-for="`field-${item}`"
                label-cols-md="12"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="`Kuesioner ke-${index + 1}`"
                  rules="required|max:500"
                >
                  <b-form-textarea
                    :id="`field-${item}`"
                    v-model="item.value"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end mt-3">
        <button
          type="kembali"
          class="mr-50 button-secondary"
          @click.prevent="editAction ? $router.back() : $emit('back')"
        >
          {{ editAction ? 'Kembali' : 'Sebelumnya' }}
        </button>
        <button
          type="submit"
          class="mr-50 button-primary"
          :disabled="loadingSubmit || invalid"
          @click.prevent="submit"
        >
          <b-spinner
            v-if="loadingSubmit"
            small
          />
          {{ editAction ? 'Simpan' : 'Submit' }}
        </button>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormGroup,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import { heightFade } from '@core/directives/animations'
import { komtimAxiosIns } from '@/libs/axios'
import { alertError, alertSuccess } from '@toast'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
    BSpinner,
  },
  directives: {
    heightFade,
  },
  props: {
    idTalent: {
      type: Number,
      default: 0,
    },
    detailTalent: {
      type: Object,
      default: () => {},
    },
    skillId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      loadingSubmit: false,
      questionItems: [],
      answersInitial: [],
      id: this.$route.params.id,
      alertError,
      alertSuccess,
    }
  },
  computed: {
    editAction() {
      return this.id !== undefined
    },
  },
  watch: {
    skillId: {
      handler(value) {
        if (value) {
          this.getQuestioner()
        }
      },
      immediate: true,
    },
  },
  methods: {
    submit() {
      this.loadingSubmit = true
      this.$refs.formRules.validate().then(async success => {
        if (success) {
          const data = {
            skill_id: this.skillId,
            questioner: this.questionItems.map(item => ({ questionnaire_id: item.id, answer: item.value })),
          }

          const url = `v1/talents/${this.editAction ? this.$route.params.id : this.idTalent}/store-questioner`
          await komtimAxiosIns
            .put(url, data)
            .then(() => {
              const text = 'Berhasil menambahkan data'
              const textEdit = 'Berhasil mengubah data'
              this.alertSuccess(this.editAction ? textEdit : text)

              this.$router.push({ name: 'talent' })
            })
            .catch(error => {
              this.alertError(error)

              if (error.response.status === 422) {
                this.submitErrors = Object.fromEntries(
                  Object.entries(error.response.data.data).map(
                    ([key, value]) => [key, value[0]],
                  ),
                )
              }
            })
        }
      })
    },
    async getQuestioner() {
      this.loading = true
      this.offset = 0
      const url = `v1/questioners/skill/${this.skillId}`

      await komtimAxiosIns
        .get(url)
        .then(res => {
          this.loading = false
          const { data } = res.data

          if (this.editAction && this.detailTalent.questioner) {
            this.questionItems = data.map(question => {
              const filtered = this.detailTalent.questioner.filter(answer => (answer.questionnaire_id === question.id))[0]
              const result = {
                ...question,
                value: filtered.Answer,
              }
              return result
            })
          } else {
            this.questionItems = data
          }
        })
        .catch(err => {
          this.loading = false
          this.alertError(err)
        })
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style lang="scss" scoped>
@import './style/Quiz.scss';
</style>
